import '../input/select-input';

import{ html, LitElement } from 'lit';
import { customElement, query } from 'lit/decorators.js';
import { SignalWatcher } from '@lit-labs/signals';

import { cartStore } from '../../_stores/cart-store';

@customElement('cart-message')
export class CartMessage extends SignalWatcher(LitElement) {

    private _messageTimer?: number = null;

    @query('.u-message')
    _message?: HTMLElement;

    // Lifecycle Hooks

    async connectedCallback() {
        super.connectedCallback();

        // add classes
        this.classList.add('CartMessage');
    }

    protected updated() {
        const cartMessage = cartStore.message.get();
        if (cartMessage) {
            if (this._messageTimer) clearTimeout(this._messageTimer);
            setTimeout(() => {
                cartStore.message.set(null);
            }, 2000)
        }
    }

    // Render

    render() {
        const cartMessage = cartStore.message.get();
        return (cartMessage)
            ? html`<div class="u-message u-message--temporary">${ cartMessage }</div>`
            : '';
    }

    createRenderRoot() { 
        return this;
    }

}